import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25b926f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-3 bg-red" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "text-size-14 text-white" }
const _hoisted_4 = { class: "text-size-12 text-white ml-2 mt-2 mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FeatherIcon, {
        icon: "alert-circle",
        size: "24",
        class: "mr-2 text-white alert-circle"
      }),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.details), 1)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.comment), 1)
  ]))
}